import { cloneElement, Fragment, ReactElement, ReactNode, useState } from "react";
import { ExportButton, ListProps, TopToolbar } from "react-admin";
import { DialogCreate } from ".";
import { List } from "@react-admin/ra-rbac";
import { ImportButton } from "react-admin-import-csv";

export interface DialogListProps extends ListProps {
    resource: string;
    dialog: ReactElement;
    dialogCreate?: any;
    children: any;
    create?: boolean;
    edit?: boolean;
    id?: any;
    importer?: any;
    buttons?: ReactNode[]
};

const check = (checkAttribute) => {
    if (typeof checkAttribute === "string") {
        return checkAttribute === "true";
    } else if (typeof checkAttribute === "boolean") {
        return checkAttribute;
    } else {
        return checkAttribute();
    }
};

const DialogListToolbar = ({ create, exporter, onCreate, baseProps, importer, buttons }) => {
    importer = check(importer);
    return <TopToolbar>
        {buttons && buttons.map((button, index) => (
            <Fragment key={index}>{button}</Fragment>
        ))}
        {create && <DialogCreate onClick={onCreate} />}
        {exporter !== false && <ExportButton {...baseProps} />}
        {importer !== false && <ImportButton {...baseProps} {...importer} />}
    </TopToolbar>
};

const DialogList = (props: DialogListProps) => {
    const [recordCreate, setRecordCreate] = useState(null);
    const [record, setRecord] = useState(null);
    const { create, edit, dialog, dialogCreate, children, importer, buttons, ...propsOtherForList } = props;
    const { resource, id } = props;
    const baseProps = {
        resource,
        basePath: `/${resource}`
    }
    const propsUpdate = {
        ...baseProps,
        record,
        setRecord,
    }
    const { exporter } = propsOtherForList;
    const onCreate = dialogCreate ? setRecordCreate : setRecord;
    const propsList = {
        ...propsOtherForList,
        ...baseProps,
        hasCreate: create,
        hasEdit: edit
    }
    return <Fragment key={`list${id}`}>
        {cloneElement(dialog, propsUpdate)}
        {dialogCreate && cloneElement(dialogCreate, {
            ...baseProps,
            record: recordCreate,
            setRecord: setRecordCreate
        })}
        <List {...propsList} actions={<DialogListToolbar buttons={buttons} baseProps={baseProps} create={create} exporter={exporter} onCreate={onCreate} importer={importer} />}>
            {cloneElement(children, { ...propsUpdate })}
        </List>
    </Fragment >
};

DialogList.defaultProps = {
    create: true,
    importer: false
};

export default DialogList;

